// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 534400719
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

export interface getHealthCheckDetails_Filter {
  logLevel: number;
}

@Injectable({
  providedIn: 'root',
})
export class HealthApiService {
  constructor(protected http: HttpClient) {}

  getHealthCheckSummary(): Observable<number> {
    const url = environment.chiliSauceApiRoot + `/api/Health`;
    return this.http.get<number>(url);
  }

  getHealthCheckDetails(
    queryParams?: Partial<getHealthCheckDetails_Filter>
  ): Observable<number> {
    const url = environment.chiliSauceApiRoot + `/api/Health/details`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<number>(url, { params: params });
  }

  clearHealthCheckCache(): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Health/clear-cache`;
    return this.http.get<any>(url);
  }
}
